if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector('form');
          this.variantIdInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
  
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
          this.hideErrors = this.dataset.hideErrors === 'true';
        }
  
        async onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
          this.handleErrorMessage();
  
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
  
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            // Use cart URL instead of product URL to avoid issues when product URL contains "cart"
            // This ensures cart-drawer section is always included in the response
            const sectionsUrl = window.location.pathname.includes('/products/') && window.location.pathname.toLowerCase().includes('cart')
              ? window.routes?.cart_url || '/cart'
              : window.location.pathname;
            formData.append('sections_url', sectionsUrl);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
  
  
  
          function cart_mySwiper(){
            console.log("123")
            var swiper = new Swiper(".cart_mySwiper", {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                
                navigation: {
                  nextEl: ".cart_collection .swiper-button-next",
                  prevEl: ".cart_collection .swiper-button-prev",
                }, 
              });
            }
            setTimeout(() => { 
              cart_mySwiper();
  
            }, 2500);  //延迟执行 1 秒
            
  
  
     
  
  
              
  
  
          
          let product_list = [];
          const product_form_dom = document.querySelector(
            ".product__info-container .sales-activities"
          );

          if (product_form_dom) {
            const product_items =
              product_form_dom.querySelectorAll(".product-item");
            product_items?.forEach((row) => {
              if (row.getAttribute("data-choose") !== "true") return;
              const id = row.getAttribute("data-product-id");
              const qtyInput = row.querySelector(
                ".sales-activities-quantity .quantity__input"
              );
              let quantity = 1;
              if (qtyInput) {
                const parsed = parseInt(qtyInput.value, 10);
                if (!Number.isNaN(parsed) && parsed > 0) quantity = parsed;
              }
              if (quantity < 1) return;
              product_list.push({ id, quantity });
            });
          }
          const data = {
            items: [],
            sections: "cart-drawer,cart-icon-bubble",
          };

          if (product_list.length > 0) {
            product_list.forEach((item) => {
              data.items.push({
                id: item.id,
                quantity: item.quantity,
              });
            });


            await fetch(`${routes.cart_add_url}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            });
          }
  
  
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
  
              CartPerformance.measureFromEvent("add:user-action", evt);
            });
        }
  
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
  
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
  
        toggleSubmitButton(disable = true, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
  
        get variantIdInput() {
          return this.form.querySelector('[name=id]');
        }
      }
    );
  }
  